export type Proposition = "Peacock" | "SkyShowtime" | "NowTV";

export const BACKEND_BASE_URL = window.env?.BACKEND_URL;
export const PROPOSITION = window.env?.PROPOSITION as Proposition;
export const METRICS_URL = window.env?.METRICS_URL;

const validateEnvConfig = () => {
  if (!BACKEND_BASE_URL || !PROPOSITION || !METRICS_URL) {
    window.location.assign("/config-error.html");
  }
};

// Validate environment config immediately upon source code load
validateEnvConfig();

export const exportForTesting = {
  validateEnvConfig,
};
